﻿
(function ($) {

  $.widget('lb.megadropdown', {
    options: {
      megaWrapper: '#md',
      hoverClass: 'mega-hover',
      arrowClass: 'nav-toggle',
      dataName: 'mega',
      withClass: '',
      speed: 500,
      delay: 850,
      onLoad: function () { },
      beforeOpen: function () { },
      beforeClose: function () { }
    },
    _findSection: function (elem) {
      var name = elem.closest('li').data(this.options.dataName);
      return this.megaWrapper.find("." + name);
    },
    _hover: function (elem) {
      var that = this;
      elem.closest('li').addClass('active').siblings().removeClass('active');
      var section = that._findSection(elem);
      that.show(section);
    },
    _create: function () {
      var that = this;
      this.megaWrapper = $(this.options.megaWrapper), // The megadropdown object

        // Click event added to each link in navigation object
        this.element.find('.has-dropdown a, .has-dropdown .' + that.options.arrowClass).bind('click', function (e) {
          var elem = $(this);
          if ($(document.documentElement).hasClass('show-menu')) {
            // toggle submenu on mobile
            var li = elem.closest('li');
            if (li.hasClass('has-dropdown')) {
              li.toggleClass('open');
            } else {
              return;
            }
          }
          else if (!that.megaWrapper.is(":visible")) {
            if (that.options.withClass || elem.closest('li').hasClass(that.options.withClass)) {
              that._hover(elem);
            } else {
              that.hide();
            }
          } else {
            var section = that._findSection(elem);
            if (!section.is(":visible")) {
              elem.closest('li').addClass('active').siblings().removeClass('active');
              that.show(section);
            } else {
              that.hide();
            }
          }
          e.preventDefault();
        });

      // Click on body to close
      $('body').bind('mouseup', function (e) {
        if (!$(e.target).parents('.' + that.options.hoverClass).length && !$(e.target).parents('.jquery-lightbox').length) {
          that.hide();
        }
      });

      //Hide when pushed on esc
      $(document).keydown(function (e) {
        var key = e.keyCode;
        if (key == 27) {
          that.hide();
        }
      });

      this.options.onLoad.call(this);
    },
    show: function (section) {
      // Display a specific section within the wrapper					
      if (section) {
        this._showSection(section);
      }

      // Let's display the wrapper
      this.element.addClass(this.options.hoverClass);
      this.megaWrapper.addClass(this.options.hoverClass);

      this.megaWrapper.slideDown(this.options.speed, function () {
        window.global.fadeInOverlay(250);
      });

      this._adjustHeight();

      // beforeOpen callback;
      this.options.beforeOpen.call(this);
    },
    _adjustHeight: function () {
      // Set all list items in a row to the same height
      this.megaWrapper.find('.row:visible').justify();
    },
    _showSection: function (section) {
      // Hide all sections
      this.megaWrapper.find(".mega-inner > div").hide();
      section.show();
    },
    hide: function () {
      var that = this;

      var after = function () {
        window.global.hideOverlay();
        that.element.removeClass(that.options.hoverClass);
        that.megaWrapper.removeClass(that.options.hoverClass);
        that.element.find('li').removeClass('active');
      };

      this.megaWrapper.slideUp(this.options.speed, after);
    }
  });

})(jQuery);
